<template>
    <div>
        <div
            style="
                margin-left: 10px;
                overflow-y: scroll;
                width: 95%;
                height: 220px;
                display: block;
                padding-right: 10px;
                padding-left: 10px;
            "
        >
            <div v-if="addCallbackVerified">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <div style="">
                        <v-text-field
                            label="Din e-post"
                            clearable
                            v-model="phoneNumber"
                            number
                            light
                            color="#006eb0"
                            class="custom-label-color"
                            :rules="rulesEmail"
                        ></v-text-field>
                    </div>
                    <div>
                        <v-textarea
                            style="margin-bottom: 20px"
                            color="#006eb0"
                            counter
                            rows="2"
                            label="Text"
                            v-model="message"
                            :rules="rulesTextField"
                            :value="value"
                            placeholder="Skriv ditt meddelande."
                        ></v-textarea>
                        <v-btn
                            color="#006eb0"
                            style="color: white"
                            :disabled="!valid"
                            @click="addCallback(user.userId, user.email)"
                        >
                            Skicka e-post
                        </v-btn>
                    </div>
                </v-form>
            </div>
            <div style="padding: 20px" v-else>
                <h3>Tack för ditt meddelande!</h3>
                <div>Vi återkommer så snart som möjligt</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['user'],
        data() {
            return {
                addCallbackVerified: true,
                valid: false,
                phoneNumber: '',
                message: '',
                value: '',
                lazy: false,
                rulesEmail: [
                    (v) => !!v || 'Du måste skriva en e-post',
                    (v) => /.+@.+\..+/.test(v) || 'E-posten är inte korrekt.'
                ],
                rulesTextField: [
                    (v) => v.length <= 160 || 'Max 160 ord.',
                    (v) => !!v || 'Du måste skriva något.',
                    (v) => v.length > 5 || 'Du måste skriva minst 5 ord.'
                ]
            };
        },
        mounted() {
            if (localStorage.getItem('visitorInfo') !== null) {
                const emailFromLocalStorage = JSON.parse(localStorage.getItem('visitorInfo'));
                this.phoneNumber = emailFromLocalStorage.visitorEmail;
            }
        },
        methods: {
            addCallback(userId, email) {
                const visitorId = localStorage.getItem('visitorId');
                const dataToSend = {
                    userId: userId,
                    message: this.message,
                    visitorInfo: { visitorEmail: this.phoneNumber },
                    type: 'email',
                    visitorId: visitorId,
                    agentEmail: ''
                };

                this.$store.dispatch('sendCallback', dataToSend);

                this.addCallbackVerified = false;
                let self = this;
                setTimeout(() => {
                    self.addCallbackVerified = true;
                    self.callbackCall(userId);
                }, 5000);
            }
        }
    };
</script>
<style scoped>
    .v-application div.v-text-field--outlined {
        color: black !important;
    }
    .v-text-field--outlined.v-input--is-focused fieldset,
    .v-text-field--outlined.v-input--has-state fieldset {
        border-color: transparent !important;
    }
</style>
